module.exports = __webpack_public_path__ + "img/onboarding.f575e741.png";